import axios from 'axios';
import apiConfig from '../api.config';

export default function requestFunctionalityContract({ hotelId, suscription, functionality }) {
  const {
    host,
    URIs: { requestFunctionalityContract },
  } = apiConfig;

  const uri = `${host}${requestFunctionalityContract.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, JSON.stringify({ feature: functionality, suscription }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
